// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_STROLLERS = "%(count)s ko\u010d\u00edkov";
export const STROLLERS_SEARCH = "Vyh\u013ead\u00e1vanie";
export const STROLLERS_SEARCH_FORM_EDIT = "Upresni parametre ko\u010d\u00edka";
export const STROLLERS_SEARCH_NO_RESULTS = "Nena\u0161li sme \u017eiadne ko\u010d\u00edky, ktor\u00e9 vyhovuj\u00fa podmienkam vyh\u013ead\u00e1vania.";
export const STROLLERS_SEARCH_REMOVE_ALL = "Zru\u0161 v\u0161etko";
export const STROLLERS_SEARCH_RESULTS_BRANDS = "Podstr\u00e1nky zna\u010diek s \u010fal\u0161\u00edmi inform\u00e1ciami:";
export const STROLLERS_SEARCH_RESULTS_results = "Ko\u010d\u00edky: %(results)s ";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_NAME = "A-Z";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_PRICE_ASC = "Najlacnej\u0161ie";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_PRICE_DESC = "Najdra\u017e\u0161ie";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_RATING = "Najlep\u0161ie hodnoten\u00e9";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_RECOMMENDED = "Doporu\u010den\u00e9 redakciou";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
